import { GetStaticProps } from 'next';
import CourseGridPage from '../../components/elements/CourseGridPage';
import { GET_COURSES } from '../../queries/courses';
import { Courses } from '../../types/schema';
import { initializeApollo } from '../../utils/apollo';
import { flatten } from '../../utils/object';
import rollbar from '../../utils/rollbar';

const cursos: React.FC<{ courses: Courses[] }> = ({ courses }) => {
  return (
    <CourseGridPage
      metaTitle="Cursos - App Masters Academy - Juiz de Fora/MG"
      metaDescription="Conheça os principais cursos que temos para oferecer"
      courses={courses}
    />
  );
};

export const getStaticProps: GetStaticProps = async () => {
  const apolloClient = initializeApollo();

  try {
    const { data } = await apolloClient.query({
      query: GET_COURSES,
    });

    const newData = flatten(data);

    return {
      props: {
        courses: newData.courses,
      },
      revalidate: 60,
    };
  } catch (error) {
    rollbar.error('Error fetching courses - Cursos', { error });
    return {
      notFound: true,
    };
  }
};

export default cursos;
